import { Product } from "@deliverr/commons-clients";

export const getDefaultPackFromProduct = (product: Product) => {
  return product.productCasePacks?.find((pack) => pack.isDefaultPack);
};
